import { DeletedOutput } from '@allocab/allocab-commons-shared-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const deleteVehicle = (id: string) => driverApi.delete<DeletedOutput>(`/v1/vehicle/${id}`);

export const useDeleteVehicle = () =>
  useMutation<DeletedOutput, unknown, string, string>({
    mutationFn: deleteVehicle,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.user.fetchVehicles());
    },
  });
